<div class="content">
  <div class="background-picture">
  </div>
  <app-content-card>
      <h3>Handelingsperspectief Login</h3>
      <app-custom-button [buttonSettings]="buttonSettings" (click)="submit()">Login</app-custom-button>
  </app-content-card>
</div>
